import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { confirmExternalFlightBookingDetailsApi } from './confirmExternalFlightBookingDetails.api'
import confirmExternalFlightBookingDetailsInitialState from './confirmExternalFlightBookingDetails.initialState'
import {
  ConfirmExternalFlightBookingDetailsErrorResponse,
  ConfirmExternalFlightBookingDetailsRequestPayload
} from './confirmExternalFlightBookingDetails.types'

export const confirmExternalFlightBookingDetails = createAsyncThunk(
  urls.flights.confirmExternalFlightBookingDetails,
  async (payload: ConfirmExternalFlightBookingDetailsRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess, onError } = payload

    try {
      const response = await confirmExternalFlightBookingDetailsApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      onError && onError()

      errorHandler.handleApiError(error as ApiErrorResponse, undefined, true)

      return rejectWithValue(error)
    }
  }
)

const confirmExternalFlightBookingDetailsSlice = createSlice({
  name: urls.flights.confirmExternalFlightBookingDetails,
  initialState: confirmExternalFlightBookingDetailsInitialState,
  reducers: {
    resetConfirmExternalFlightBookingDetails: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(confirmExternalFlightBookingDetails.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(confirmExternalFlightBookingDetails.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(confirmExternalFlightBookingDetails.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as ConfirmExternalFlightBookingDetailsErrorResponse
        state.success = null
      })
  }
})

export const {
  actions: confirmExternalFlightBookingDetailsActions,
  reducer: confirmExternalFlightBookingDetailsReducer
} = confirmExternalFlightBookingDetailsSlice
export const { resetConfirmExternalFlightBookingDetails } = confirmExternalFlightBookingDetailsActions
export default confirmExternalFlightBookingDetailsSlice.reducer
